import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Toolbar from 'src/components/Toolbar';
import HomeToolbar from 'src/components/HomeToolbar';
import FunctionBlock from './FunctionBlock';
import HomeSlider, { HomeSliderInterface } from 'src/components/HomeSlider';
import HomeProductOnline from 'src/components/HomeProductOnline';
import './style.scoped.css';
import usePullToRefresh from 'src/hooks/usePullToRefresh';
import Loading from 'src/components/Loading';
import HomeNewsAndPromotion, {
  HomeNewsAndPromotionProps,
} from 'src/components/HomeNewsAndPromotion';
import HomeSkeleton from 'src/components/HomeSkeleton';
import homeStore, { HomeStore } from 'src/stores/HomeStore';
import cancerStore, { CancerStore } from 'src/stores/CancerStore';
import { observer } from 'mobx-react-lite';
import { goBack } from 'src/utils';
import PopupService from '../../utils/PopupService';
import i18n from '../../lang/i18n';
interface HomeProductProps extends HomeSliderInterface {
  store?: HomeStore;
}

const HomeProduct = observer((props: HomeProductProps) => {
  const { store, ...passProps } = props;
  return <HomeSlider data={store.homeProduct} {...passProps} />;
});

interface HomeNewsAndPromotionObserverProps extends HomeNewsAndPromotionProps {
  store?: HomeStore;
}

const HomeNewsAndPromotionObserver = observer(
  (props: HomeNewsAndPromotionObserverProps) => {
    const { store, ...passProps } = props;
    return <HomeNewsAndPromotion data={store.homeEvent} {...passProps} />;
  }
);

interface HomeObserverProps {
  homeStore?: HomeStore;
  cancerStore?: CancerStore;
}
const HomeObserver = observer(
  ({ homeStore, cancerStore }: HomeObserverProps) => {
    const _load = useCallback(() => {
      homeStore.fetchHomeData();
      cancerStore.fetchCategory();

      PopupService.instance.current.open({
        visible: true,
        title: i18n.t('notification'),
        content: 'Chức năng đang bảo trì. Để sử dụng các dịch vụ của Công ty Bảo hiểm nhân thọ MB Ageas (MB Life), Quý khách vui lòng truy cập "Cổng bảo hiểm MB" (trong danh mục Tiền gửi & đầu tư; hoặc trong Dịch vụ tập đoàn - sau khi nâng cấp phiên bản ứng dụng mới). Cảm ơn Quý khách.',
        okTitle: i18n.t('close'),
        onOk: () => {
          if (window?.ReactNativeWebView) {
            window?.ReactNativeWebView?.postMessage(
              JSON.stringify({
                type: 'go_back',
                source: 'web_mobile',
              })
            );
          }
        },
        showIcon: false,
      });

    }, [homeStore, cancerStore]);
    // Pull to refresh
    usePullToRefresh('.refreshContent', <Loading type={'small'} />, _load);

    const { t } = useTranslation();
    const _handleBack = useCallback(() => {
      goBack();
    }, []);

    useEffect(() => {
      _load();
      cancerStore.cleanFormInfo();
    }, [_load, cancerStore]);

    return (
      <div className="screen-container bg-surface fix-scroll">
        <div>
          {homeStore.homeLoading ? (
            <HomeSkeleton />
          ) : (
            <>
              <div className="bg-primaryVariant">
                <Toolbar
                  title={t('logo')}
                  type={'onPrimary'}
                  onBack={_handleBack}
                  showLine={false}
                />
              </div>
              <div className="screenScrollContainerWithoutButton max-w-md mx-auto pb-4 refreshContent">
                <HomeToolbar title={t('logo')} />
                <div className="mainContent">
                  <div className="homeBlock">
                    <FunctionBlock />
                  </div>
                  <div className="homeBlock">
                    <HomeProductOnline
                      store={homeStore}
                      title={t('buy_insurance_online')}
                    />
                  </div>
                  <div className="homeBlock">
                    <HomeProduct
                      store={homeStore}
                      title={t('insurance_product')}
                      type={'itemStory'}
                      viewAllPath={'/product_list'}
                    />
                  </div>
                  {/* className="homeBlockWithoutLine" */}
                  <div>
                    <HomeNewsAndPromotionObserver
                      store={homeStore}
                      title={t('new_and_discount')}
                      viewAllPath={'/news_and_promotion'}
                    />
                  </div>
                  <div className="h-8" />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
);

const Home = () => {
  return <HomeObserver homeStore={homeStore} cancerStore={cancerStore} />;
};

export default Home;
